import * as $runtime from "../runtime.js";
import * as Codec$dJSON$dDecodeError from "../Codec.JSON.DecodeError/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dCodec from "../Data.Codec/index.js";
import * as Data$dCodec$dJSON from "../Data.Codec.JSON/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as JSON$dInternal from "../JSON.Internal/index.js";
import * as JSON$dPath from "../JSON.Path/index.js";
const taggedSum = name => printTag => parseTag => f => g => Data$dCodec.$Codec(
  j => {
    const $0 = "Could not decode " + name;
    const $1 = Data$dCodec$dJSON.jobject._1(j);
    const $2 = (() => {
      if ($1.tag === "Left") {
        const $2 = $1._1;
        return v => Data$dEither.$Either("Left", $2);
      }
      if ($1.tag === "Right") {
        const $2 = $1._1;
        return f$1 => f$1($2);
      }
      $runtime.fail();
    })()(obj => {
      const $2 = Data$dCodec$dJSON.prop("tag")(Data$dCodec$dJSON.string)._1(obj);
      return (() => {
        if ($2.tag === "Left") {
          const $3 = $2._1;
          return v => Data$dEither.$Either("Left", $3);
        }
        if ($2.tag === "Right") {
          const $3 = $2._1;
          return f$1 => f$1($3);
        }
        $runtime.fail();
      })()(tag => {
        const v = parseTag(tag);
        if (v.tag === "Nothing") {
          return Data$dEither.$Either("Left", {path: JSON$dPath.$Path("AtKey", "tag", JSON$dPath.Tip), message: "Unexpected value '" + tag + "' found", causes: []});
        }
        if (v.tag === "Just") {
          const v1 = f(v._1);
          if (v1.tag === "Left") { return Data$dEither.$Either("Right", v1._1); }
          if (v1.tag === "Right") {
            const $3 = Data$dCodec$dJSON.prop("value")(Data$dCodec$dJSON.json)._1(obj);
            return (() => {
              if ($3.tag === "Left") {
                const $4 = $3._1;
                return v$1 => Data$dEither.$Either("Left", $4);
              }
              if ($3.tag === "Right") {
                const $4 = $3._1;
                return f$1 => f$1($4);
              }
              $runtime.fail();
            })()(value => {
              const $4 = Codec$dJSON$dDecodeError.withPath(JSON$dPath.AtKey("value"));
              const $5 = v1._1(value);
              if ($5.tag === "Left") { return Data$dEither.$Either("Left", $4($5._1)); }
              if ($5.tag === "Right") { return Data$dEither.$Either("Right", $5._1); }
              $runtime.fail();
            });
          }
        }
        $runtime.fail();
      });
    });
    if ($2.tag === "Left") { return Data$dEither.$Either("Left", {path: $2._1.path, message: $0, causes: [$2._1]}); }
    if ($2.tag === "Right") { return Data$dEither.$Either("Right", $2._1); }
    $runtime.fail();
  },
  b => Data$dTuple.$Tuple(
    (() => {
      const v = g(b);
      return Data$dCodec$dJSON.jobject._2(JSON$dInternal._fromEntries(
        Data$dTuple.fst,
        Data$dTuple.snd,
        Data$dArray.mapMaybe(x => x)([
          Data$dMaybe.$Maybe("Just", Data$dTuple.$Tuple("tag", Data$dCodec$dJSON.string._2(printTag(v._1))._1)),
          (() => {
            const $0 = Data$dTuple.Tuple("value");
            if (v._2.tag === "Just") { return Data$dMaybe.$Maybe("Just", $0(v._2._1)); }
            return Data$dMaybe.Nothing;
          })()
        ])
      ))._1;
    })(),
    b
  )
);
const enumSum = printTag => parseTag => Data$dCodec.$Codec(
  json => {
    const $0 = Data$dCodec$dJSON.string._1(json);
    return (() => {
      if ($0.tag === "Left") {
        const $1 = $0._1;
        return v => Data$dEither.$Either("Left", $1);
      }
      if ($0.tag === "Right") {
        const $1 = $0._1;
        return f => f($1);
      }
      $runtime.fail();
    })()(tag => {
      const v = parseTag(tag);
      if (v.tag === "Nothing") { return Data$dEither.$Either("Left", {path: JSON$dPath.Tip, message: "Unexpected value '" + tag + "' found", causes: []}); }
      if (v.tag === "Just") { return Data$dEither.$Either("Right", v._1); }
      $runtime.fail();
    });
  },
  b => Data$dTuple.$Tuple(Data$dCodec$dJSON.string._2(printTag(b))._1, b)
);
export {enumSum, taggedSum};
